module.exports = __webpack_public_path__ + "static/media/no_image.4b22b126.png";